/* alma deploy-bump 20260612T103640 force-cdn-version */
/**
 * alma-tracking-capture.js
 * v7.1 — cart-attribute relay for checkout attribution 2026-06-07
 *
 * ADDITIVE over v6. All v6 behaviour preserved unchanged:
 *   - gclid/wbraid/gbraid/fbclid/dclid/msclkid + UTM capture to cookies
 *   - traffic_type=internal session cookie detection
 *   - Form detection & GA4/Meta event firing (contact, product-inquiry, RSVP)
 *   - Hidden field population on submit
 *   - Meta Pixel lazy init (fbq)
 *
 * NEW in v7 — cart-attribute relay (Fix 1 of the checkout-attribution build):
 *   Reads the GA4 client_id (_ga cookie) and session_id (_ga_X0N6S2HNN9 cookie),
 *   plus the existing gclid/UTM cookies, and writes them as underscore-prefixed
 *   Shopify cart attributes via POST /cart/update.js.
 *
 *   Trigger points:
 *     a) document DOMContentLoaded (catches cart-page loads and all page loads)
 *     b) Shopify 'cart:updated' custom event (fired by many themes on add-to-cart)
 *     c) MutationObserver on form[action="/cart/add"] submit buttons (Buy Now /
 *        accelerated checkout paths that don't emit the theme event)
 *     d) Debounced 800 ms fallback after any add-to-cart form submission detected
 *        via a delegated submit listener
 *
 *   Cart attributes written:
 *     alma_cid        — GA4 client_id (e.g. "1234567890.1234567890")
 *     alma_sid        — GA4 session_id (e.g. "1717000000")
 *     _alma_gclid     — Google click ID (if present)
 *     _alma_wbraid    — wbraid (if present)
 *     _alma_gbraid    — gbraid (if present)
 *     _alma_utm_src   — utm_source (if present)
 *     _alma_utm_med   — utm_medium (if present)
 *     _alma_utm_cam   — utm_campaign (if present)
 *
 *   The relay is wrapped entirely in try/catch. Any failure is silent — it can
 *   NEVER break existing tracking, form events, or the checkout flow.
 *
 *   The MP purchase-attribution pixel (Fix 2, a separate Customer Events custom
 *   pixel) reads these cart attributes from checkout.attributes on
 *   checkout_completed, and if alma_cid is present, fires a Measurement
 *   Protocol purchase hit to GA4 with the correct client_id so the purchase is
 *   attributed to the real acquisition channel (not "Unassigned").
 *
 * NOTE: SHOP-12 (overcounting from submit-attempt-instead-of-submit-success
 * firing) is OPEN. Events fire on submit — submissions blocked by hCaptcha /
 * network drops / server validation still register a GA4 event.
 *
 * Deploy to: assets/alma-tracking-capture.js
 * Loaded from layout/theme.liquid before </body>:
 *   <script src="{{ 'alma-tracking-capture.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  // ── Meta Pixel lazy init ───────────────────────────────────────────────────
  (function ensureAlmaPixelInit() {
    if (window._almaFbqInitialized) return;
    var attempts = 0;
    var MAX_ATTEMPTS = 50;
    function tryInit() {
      if (window._almaFbqInitialized) return;
      if (typeof window.fbq === 'function') {
        try {
          window.fbq('init', '2014443428827975');
          window._almaFbqInitialized = true;
        } catch (e) {}
        return;
      }
      if (++attempts < MAX_ATTEMPTS) setTimeout(tryInit, 100);
    }
    tryInit();
  })();

  var COOKIE_PREFIX = 'alma_attr_';
  var EXPIRY_DAYS = 90;
  var PARAMS = [
    'gclid', 'wbraid', 'gbraid', 'fbclid', 'dclid', 'msclkid',
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'
  ];
  var FORM_DESTINATION = 'alex@almaaudio.com';
  var CONTACT_FORM_VALUE = 500;
  var RSVP_FORM_VALUE = 500;
  var PRODUCT_INQUIRY_VALUE = 2500;

  // ── Helpers ────────────────────────────────────────────────────────────────

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setSessionCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; path=/; SameSite=Lax';
  }

  function getTrafficType() {
    var match = document.cookie.match('(?:^|; )alma_traffic_type=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
  }

  function generateEventId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Date.now() + Math.random() * 16) % 16 | 0;
      Date.now();
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  // ── Step 1: Capture URL params → cookies ──────────────────────────────────

  var urlParams = new URLSearchParams(window.location.search);
  var captured = {};

  PARAMS.forEach(function (param) {
    var val = urlParams.get(param);
    if (val) {
      setCookie(COOKIE_PREFIX + param, val, EXPIRY_DAYS);
      captured[param] = val;
    }
  });

  var trafficTypeParam = urlParams.get('traffic_type');
  if (trafficTypeParam === 'internal') {
    setSessionCookie('alma_traffic_type', 'internal');
  }

  if (!getCookie(COOKIE_PREFIX + 'landing_page')) {
    setCookie(COOKIE_PREFIX + 'landing_page', window.location.href, EXPIRY_DAYS);
  }
  if (!getCookie(COOKIE_PREFIX + 'referrer_url') && document.referrer) {
    setCookie(COOKIE_PREFIX + 'referrer_url', document.referrer, EXPIRY_DAYS);
  }

  // ── Step 2: Push attribution_capture event to dataLayer ───────────────────

  window.dataLayer = window.dataLayer || [];
  if (Object.keys(captured).length > 0) {
    window.dataLayer.push({
      event: 'attribution_capture',
      alma_gclid: captured.gclid || getCookie(COOKIE_PREFIX + 'gclid') || '',
      alma_utm_source: captured.utm_source || getCookie(COOKIE_PREFIX + 'utm_source') || '',
      alma_utm_medium: captured.utm_medium || getCookie(COOKIE_PREFIX + 'utm_medium') || '',
      alma_utm_campaign: captured.utm_campaign || getCookie(COOKIE_PREFIX + 'utm_campaign') || ''
    });
  }

  // ── Step 3: Form detection ─────────────────────────────────────────────────

  function isRsvpForm(form) {
    var ft = form.querySelector('input[name="contact[form_type]"]');
    return !!(ft && ft.value === 'rsvp');
  }

  function isProductInquiryForm(form) {
    if (form.id && form.id.indexOf('product-request') !== -1) return true;
    if (form.querySelector('input[name="contact[product]"]')) return true;
    if (typeof form.className === 'string' &&
        form.className.indexOf('product-request-form') !== -1) return true;
    return false;
  }

  function isContactForm(form) {
    if (!form || !(form instanceof HTMLFormElement)) return false;
    var action = form.getAttribute('action') || '';
    var matchesAction = action === '/contact' ||
                        action.indexOf('/contact?') === 0 ||
                        action.indexOf('/contact#') === 0;
    var matchesTemplate = !!form.closest('[data-template-contact]');
    if (!matchesAction && !matchesTemplate) return false;
    var formTypeField = form.querySelector('input[name="form_type"]');
    if (formTypeField && formTypeField.value === 'customer') return false;
    return true;
  }

  // ── Step 4: Hidden field population ───────────────────────────────────────

  function populateHiddenFields(form) {
    PARAMS.forEach(function (param) {
      var fieldName = 'contact[' + param + ']';
      var field = form.querySelector('[name="' + fieldName + '"]');
      if (field) {
        var val = getCookie(COOKIE_PREFIX + param) || '';
        if (val && !field.value) field.value = val;
      }
    });
    ['landing_page', 'referrer_url'].forEach(function (key) {
      var field = form.querySelector('[name="contact[' + key + ']"]');
      if (field && !field.value) {
        field.value = getCookie(COOKIE_PREFIX + key) || '';
      }
    });
  }

  // ── Step 5: Event firing ───────────────────────────────────────────────────

  function fireRsvpSubmitEvent(form) {
    var gclidValue = getCookie(COOKIE_PREFIX + 'gclid') || '';
    var formId = form.id || 'rsvp-form';
    var locationField = form.querySelector('input[name="contact[rsvp_location]"]');
    var location = locationField ? locationField.value : '';
    var formName = location === 'alma_west' ? 'RSVP Alma West' :
                   location === 'alma_east' ? 'RSVP Alma East' :
                   'RSVP';
    var eventId = generateEventId();
    if (typeof gtag === 'function') {
      gtag('event', 'form_submit', {
        form_id: formId,
        form_name: formName,
        form_destination: FORM_DESTINATION,
        value: RSVP_FORM_VALUE,
        currency: 'USD',
        gclid: gclidValue,
        click_id: gclidValue,
        traffic_type: getTrafficType() || undefined
      });
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        value: RSVP_FORM_VALUE,
        currency: 'USD'
      }, { eventID: eventId });
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_submit',
      form_id: formId,
      form_name: formName,
      form_destination: FORM_DESTINATION,
      value: RSVP_FORM_VALUE,
      currency: 'USD',
      alma_gclid: gclidValue,
      click_id: gclidValue
    });
  }

  function fireContactSubmitEvent(form) {
    var gclidValue = getCookie(COOKIE_PREFIX + 'gclid') || '';
    var formId = form.id || 'contact-us-native';
    var eventId = generateEventId();
    if (typeof gtag === 'function') {
      gtag('event', 'form_submit', {
        form_id: formId,
        form_name: 'Contact Us',
        form_destination: FORM_DESTINATION,
        value: CONTACT_FORM_VALUE,
        currency: 'USD',
        gclid: gclidValue,
        click_id: gclidValue,
        traffic_type: getTrafficType() || undefined
      });
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        value: CONTACT_FORM_VALUE,
        currency: 'USD'
      }, { eventID: eventId });
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_submit',
      form_id: formId,
      form_name: 'Contact Us',
      form_destination: FORM_DESTINATION,
      value: CONTACT_FORM_VALUE,
      currency: 'USD',
      alma_gclid: gclidValue,
      click_id: gclidValue
    });
  }

  function fireProductInquiryEvent(form) {
    var gclidValue = getCookie(COOKIE_PREFIX + 'gclid') || '';
    var productTitle = (form.querySelector('input[name="contact[product]"]') || {}).value || '';
    var sku = (form.querySelector('input[name="contact[sku]"]') || {}).value || '';
    var formId = form.id || 'product-request-form';
    var eventId = generateEventId();
    if (typeof gtag === 'function') {
      gtag('event', 'product_inquiry', {
        form_id: formId,
        form_name: 'Product Inquiry',
        form_destination: FORM_DESTINATION,
        product_title: productTitle,
        sku: sku,
        value: PRODUCT_INQUIRY_VALUE,
        currency: 'USD',
        gclid: gclidValue,
        click_id: gclidValue,
        traffic_type: getTrafficType() || undefined
      });
    }
    if (typeof window.fbq === 'function') {
      var fbqParams = {
        value: PRODUCT_INQUIRY_VALUE,
        currency: 'USD',
        content_type: 'product'
      };
      if (sku) fbqParams.content_ids = [sku];
      window.fbq('track', 'Lead', fbqParams, { eventID: eventId });
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'product_inquiry',
      form_id: formId,
      form_name: 'Product Inquiry',
      form_destination: FORM_DESTINATION,
      product_title: productTitle,
      sku: sku,
      value: PRODUCT_INQUIRY_VALUE,
      currency: 'USD',
      alma_gclid: gclidValue,
      click_id: gclidValue
    });
  }

  // ── Step 6: Delegated submit listener ─────────────────────────────────────

  document.addEventListener('submit', function (e) {
    var form = e.target;

    if (isRsvpForm(form)) {
      populateHiddenFields(form);
      fireRsvpSubmitEvent(form);
      return;
    }

    if (isProductInquiryForm(form)) {
      populateHiddenFields(form);
      fireProductInquiryEvent(form);
      return;
    }

    if (isContactForm(form)) {
      populateHiddenFields(form);
      fireContactSubmitEvent(form);
    }
  }, true);

  // Defensive cleanup: remove stale SHOP-12 pending data
  try { sessionStorage.removeItem('alma_pending_form_event'); } catch (e) {}

  // ═══════════════════════════════════════════════════════════════════════════
  // v7 NEW: Cart-attribute relay for checkout purchase attribution
  // ═══════════════════════════════════════════════════════════════════════════
  //
  // All code below is wrapped in a single try/catch guard. A failure here
  // is logged to console (debug only) and NEVER propagates to break existing
  // tracking or the checkout flow.

  try {
    // ── GA4 client_id / session_id extraction ─────────────────────────────
    //
    // _ga cookie format: GA1.1.<client_id_part1>.<client_id_part2>
    //   The client_id passed to GA4 events is "<part1>.<part2>" (no "GA1.1." prefix).
    // _ga_XXXXXXXXXX cookie format:
    //   GS1: GS1.1.<session_id>.<session_count>.<last_engage>... (older format)
    //   GS2: GS2.1.s<session_id>$o<count>$g...                  (GA4 2024+ format)
    //   session_id is the numeric value extracted from the third dot-delimited segment.

    function getGA4ClientId() {
      var raw = getCookie('_ga');
      if (!raw) return null;
      // Format: GA1.1.XXXXXXXXXX.XXXXXXXXXX  or  GA1.2.XXXXXXXXXX.XXXXXXXXXX
      var parts = raw.split('.');
      if (parts.length >= 4) return parts[2] + '.' + parts[3];
      return null;
    }

    function getGA4SessionId() {
      // The stream-specific cookie for G-X0N6S2HNN9 is _ga_X0N6S2HNN9
      var raw = getCookie('_ga_X0N6S2HNN9');
      if (!raw) return null;
      // GS1 format: GS1.1.<session_id>.<session_count>.<...>  — third dot-segment is numeric
      // GS2 format: GS2.1.s<session_id>$o<count>$g<...>      — third dot-segment starts with 's'
      var parts = raw.split('.');
      if (parts.length < 3) return null;
      var seg = parts[2];
      // GS2: strip leading 's' and take everything before the first '$'
      if (seg.charAt(0) === 's') {
        var num = seg.substring(1).split('$')[0];
        return num || null;
      }
      // GS1: segment is the bare numeric session_id
      return seg;
    }

    // ── Build the cart attribute payload ──────────────────────────────────

    function buildCartAttributes() {
      var attrs = {};
      var cid = getGA4ClientId();
      var sid = getGA4SessionId();
      if (cid) attrs['alma_cid'] = cid;
      if (sid) attrs['alma_sid'] = sid;
      var gclid = getCookie(COOKIE_PREFIX + 'gclid');
      if (gclid) attrs['_alma_gclid'] = gclid;
      var wbraid = getCookie(COOKIE_PREFIX + 'wbraid');
      if (wbraid) attrs['_alma_wbraid'] = wbraid;
      var gbraid = getCookie(COOKIE_PREFIX + 'gbraid');
      if (gbraid) attrs['_alma_gbraid'] = gbraid;
      var utmSrc = getCookie(COOKIE_PREFIX + 'utm_source');
      if (utmSrc) attrs['_alma_utm_src'] = utmSrc;
      var utmMed = getCookie(COOKIE_PREFIX + 'utm_medium');
      if (utmMed) attrs['_alma_utm_med'] = utmMed;
      var utmCam = getCookie(COOKIE_PREFIX + 'utm_campaign');
      if (utmCam) attrs['_alma_utm_cam'] = utmCam;
      return attrs;
    }

    // ── POST to /cart/update.js ────────────────────────────────────────────
    //
    // Only fires if at least alma_cid is present — if there's no GA4
    // client_id in the browser, there's nothing useful to relay.
    // Uses keepalive:true so the request survives navigation to checkout.

    var _almaCartRelayInFlight = false;

    function relayCartAttributes() {
      try {
        var attrs = buildCartAttributes();
        if (!attrs['alma_cid']) return; // nothing to relay

        // Avoid flooding with concurrent requests
        if (_almaCartRelayInFlight) return;
        _almaCartRelayInFlight = true;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs }),
          keepalive: true
        }).then(function () {
          _almaCartRelayInFlight = false;
        }).catch(function () {
          _almaCartRelayInFlight = false;
        });
      } catch (e) {
        _almaCartRelayInFlight = false;
      }
    }

    // ── Trigger 1: DOMContentLoaded (cart page load + all page loads) ─────
    //
    // On the cart page, this ensures attributes are written even if the
    // visitor loaded the page without any in-session add-to-cart action.
    // On other pages the POST is cheap and idempotent — Shopify ignores
    // attribute writes when the cart is empty.

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', relayCartAttributes);
    } else {
      // Script ran after HTML parse (defer) — DOM already ready
      relayCartAttributes();
    }

    // ── Trigger 2: Shopify theme 'cart:updated' event ─────────────────────
    //
    // Most Ethos theme add-to-cart flows dispatch this on the document after
    // the fetch-based cart update completes. Re-relay after this event to
    // pick up any new session/gclid that arrived during the session.

    document.addEventListener('cart:updated', function () {
      try { relayCartAttributes(); } catch (e) {}
    });

    // ── Trigger 3: Debounced post-submit fallback ──────────────────────────
    //
    // Catches add-to-cart form submissions that don't emit 'cart:updated'
    // (e.g. Buy Now / accelerated checkout paths, third-party app cart forms).
    // Runs 800 ms after any form[action="/cart/add"] submission.

    var _almaRelayDebounceTimer = null;

    document.addEventListener('submit', function (e) {
      try {
        var form = e.target;
        if (!form || !(form instanceof HTMLFormElement)) return;
        var action = form.getAttribute('action') || '';
        if (action !== '/cart/add' &&
            action.indexOf('/cart/add?') !== 0 &&
            action.indexOf('/cart/add#') !== 0) return;
        clearTimeout(_almaRelayDebounceTimer);
        _almaRelayDebounceTimer = setTimeout(function () {
          try { relayCartAttributes(); } catch (e) {}
        }, 800);
      } catch (e) {}
    }, true);

    // ── Trigger 4: Fetch intercept for JS add-to-cart ─────────────────────
    //
    // Themes using fetch('/cart/add.js', ...) instead of a form submit won't
    // trigger the delegated form listener. Wrap fetch to detect these calls.

    (function wrapFetchForCartAdd() {
      try {
        var originalFetch = window.fetch;
        window.fetch = function (resource, options) {
          try {
            var url = (typeof resource === 'string') ? resource :
                      (resource && resource.url) ? resource.url : '';
            if (url && (url.indexOf('/cart/add') !== -1 ||
                        url.indexOf('/cart/add.js') !== -1)) {
              clearTimeout(_almaRelayDebounceTimer);
              _almaRelayDebounceTimer = setTimeout(function () {
                try { relayCartAttributes(); } catch (e) {}
              }, 800);
            }
          } catch (e) {}
          return originalFetch.apply(this, arguments);
        };
      } catch (e) {}
    })();

  } catch (outerErr) {
    // Silent — v7 cart relay failure must never surface as a user-visible error
  }

})();
